const KEY = 'knowlez.currency';

export function getPreferredCurrency(): string | null {
  try { return localStorage.getItem(KEY); } catch { return null; }
}

export function setPreferredCurrency(code: string): void {
  try { localStorage.setItem(KEY, code.toUpperCase()); } catch { /* ignore */ }
}

/**
 * Format a number as money using Intl.NumberFormat, with `tabular-nums`
 * applied at the CSS layer (`.num` class). Optional `unit` lets the
 * caller display "千円" / "百万円" / "M" / "B" as a suffix without
 * disturbing the locale-correct decimal/grouping.
 */
export function formatMoney(
  amount: number,
  opts: { currency?: string; locale?: string; unit?: '1' | '1000' | '1000000'; maximumFractionDigits?: number } = {},
): string {
  const currency = (opts.currency || getPreferredCurrency() || 'USD').toUpperCase();
  const locale = opts.locale || 'en-US';
  const unit = opts.unit ?? '1';

  const divisor = unit === '1000' ? 1_000 : unit === '1000000' ? 1_000_000 : 1;
  const display = amount / divisor;

  const formatted = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    maximumFractionDigits: opts.maximumFractionDigits ?? 0,
  }).format(display);

  if (unit === '1000') return `${formatted}k`;
  if (unit === '1000000') return `${formatted}M`;
  return formatted;
}
